import { render, staticRenderFns } from "./ClinicalManifestations.vue?vue&type=template&id=a46c8404&scoped=true&"
import script from "./ClinicalManifestations.vue?vue&type=script&lang=js&"
export * from "./ClinicalManifestations.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalManifestations.vue?vue&type=style&index=0&id=a46c8404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46c8404",
  null
  
)

export default component.exports